var map = {
	"./1.2.A. CAIAN RANDARE 1.jpg": "7viH",
	"./1.2.A. CAIAN RANDARE 2.jpg": "lSai",
	"./1.2.A. CAIAN RANDARE 3.jpg": "FzSg",
	"./1.2.A. CAIAN RANDARE 4.jpg": "0Efh"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6iRH";